export class Route {

    public path;
    public component;
    public name;
    public outlet;
    public children;
    public loadChildren;
    public canActivate = [];
    public data        = {};

    public parameters;

    constructor(path: string, component: Object, name: string, data?: Object) {

        this.path = path;

        if (typeof component === 'string') {
            this.loadChildren = component;
        } else {
            this.component = component;
        }
        this.name = name;

        if (this.path.includes(':')) {

            const parameters = [];

            const chunks = this.path.split('/');

            for (const param in chunks) {

                if (chunks.hasOwnProperty(param)) {
                    if (chunks[param].includes(':')) {

                        const key = chunks[param].replace(':', '');
                        parameters.push(key);

                    }
                }

            }

            this.parameters = parameters;

        } else {
            this.parameters = [];
        }

        if (data) {

            this.setGuards(data);

            this.data = data;
            if (data['outlet']) {
                this.outlet = data['outlet'];
            }

            if (data['children']) {
                this.children = data['children'];
            }

        }
    }

    public setGuards(data) {

        if (data['canActivate'] !== undefined) {

            this.canActivate = data['canActivate'];
            delete data['canActivate'];

        }

    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/routing/models/route.ts